/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AddressesListing from '../components/Feature/AddressesListing/AddressesListing';
import Banner from '../components/Feature/Banner/Banner';
import Cards from '../components/Feature/Cards/Cards';
import Content from '../components/Feature/Content/Content';
import ContextualBanner from '../components/Feature/ContextualBanner/ContextualBanner';
import Footer from '../components/Feature/Footer/Footer';
import Gallery from '../components/Feature/Gallery/Gallery';
import GalleryListing from '../components/Feature/GalleryListing/GalleryListing';
import Header from '../components/Feature/Header/Header';
import InitiativesAndPatronages from '../components/Feature/InitiativesAndPatronages/InitiativesAndPatronages';
import InitiativesAndPatronagesWidget from '../components/Feature/InitiativesAndPatronagesWidget/InitiativesAndPatronagesWidget';
import LatestAddresses from '../components/Feature/LatestAddresses/LatestAddresses';
import LatestNews from '../components/Feature/LatestNews/LatestNews';
import NewsListing from '../components/Feature/NewsListing/NewsListing';
import QuotesListing from '../components/Feature/QuotesListing/QuotesListing';
import RelatedNews from '../components/Feature/RelatedNews/RelatedNews';
import Search from '../components/Feature/Search/Search';
import SearchSnapshot from '../components/Feature/SearchSnapshot/SearchSnapshot';
import Testimonial from '../components/Feature/Testimonial/Testimonial';
import Timeline from '../components/Feature/Timeline/Timeline';
import Video from '../components/Feature/Video/Video';

const components = new Map();
components.set('AddressesListing', AddressesListing);
components.set('Banner', Banner);
components.set('Cards', Cards);
components.set('Content', Content);
components.set('ContextualBanner', ContextualBanner);
components.set('Footer', Footer);
components.set('Gallery', Gallery);
components.set('GalleryListing', GalleryListing);
components.set('Header', Header);
components.set('InitiativesAndPatronages', InitiativesAndPatronages);
components.set('InitiativesAndPatronagesWidget', InitiativesAndPatronagesWidget);
components.set('LatestAddresses', LatestAddresses);
components.set('LatestNews', LatestNews);
components.set('NewsListing', NewsListing);
components.set('QuotesListing', QuotesListing);
components.set('RelatedNews', RelatedNews);
components.set('Search', Search);
components.set('SearchSnapshot', SearchSnapshot);
components.set('Testimonial', Testimonial);
components.set('Timeline', Timeline);
components.set('Video', Video);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
